// Bucknell University's undergraduate majors (#2743). Read on 2026-10-01
// from the official 2026-2027 Catalog (coursecatalog.bucknell.edu): each
// college's Areas of Study pages, one per department or program, with the
// degree from the page's own headings and text, checked against the
// Curricula Overview pages (the College of Arts & Sciences overview lists the
// B.S. majors, the B.S. Ed. and the B.Mus. majors; the Freeman overview lists
// the BSBA majors and the Bachelor of Management for Engineers). Concentrations
// (Physics with astrophysics, the Music B.A. concentrations, the Management &
// Organizations concentrations) are folded into their major. The English
// department's literary studies major is named "English: Literary Studies" so
// the department shows; its other two majors are Creative Writing and Film &
// Media Studies. "German" is the catalog's "Major in German" under German
// Studies. Left out: minors, Military Science, Foundation Seminar,
// Residential College and other non-major pages. Degree abbreviations follow
// the catalog's own usage (B.A., B.S., B.S. Ed., B.Mus., BSBA, BME). The KB's
// majors list was the starting point; the catalog wins.
const majors = {
    "slug": "bucknell-university",
    "read": "2026-10-01",
    "intro": "Every bachelor's degree major in Bucknell's official 2026-2027 Catalog, grouped by the college that offers it, with the degree it leads to. Concentrations are folded into their major. Minors and graduate programs are left out.",
    "groups": [
        {
            "name": "College of Arts & Sciences",
            "source": {
                "label": "Bucknell 2026-2027 Catalog, College of Arts & Sciences, Areas of Study",
                "url": "https://coursecatalog.bucknell.edu/collegeofartsandsciencescurricula/areasofstudy/"
            },
            "majors": [
                {
                    "name": "Animal Behavior",
                    "degree": "B.A."
                },
                {
                    "name": "Animal Behavior",
                    "degree": "B.S."
                },
                {
                    "name": "Anthropology",
                    "degree": "B.A."
                },
                {
                    "name": "Applied Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Art & Design",
                    "degree": "B.A."
                },
                {
                    "name": "Art History",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.A."
                },
                {
                    "name": "Biology",
                    "degree": "B.S."
                },
                {
                    "name": "Biophysics",
                    "degree": "B.S."
                },
                {
                    "name": "Cell Biology/Biochemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.A."
                },
                {
                    "name": "Chemistry",
                    "degree": "B.S."
                },
                {
                    "name": "Chinese",
                    "degree": "B.A."
                },
                {
                    "name": "Classics & Ancient Mediterranean Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Comparative & Digital Humanities",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.A."
                },
                {
                    "name": "Computer Science",
                    "degree": "B.S."
                },
                {
                    "name": "Creative Writing",
                    "degree": "B.A."
                },
                {
                    "name": "Critical Black Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Early Childhood Education (Pre-K to grade 4)",
                    "degree": "B.S. Ed."
                },
                {
                    "name": "East Asian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Economics",
                    "degree": "B.A."
                },
                {
                    "name": "Education",
                    "degree": "B.A."
                },
                {
                    "name": "English: Literary Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Science",
                    "degree": "B.A."
                },
                {
                    "name": "Environmental Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Film & Media Studies",
                    "degree": "B.A."
                },
                {
                    "name": "French & Francophone Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Geography",
                    "degree": "B.A."
                },
                {
                    "name": "Geosciences",
                    "degree": "B.A."
                },
                {
                    "name": "Geosciences",
                    "degree": "B.S."
                },
                {
                    "name": "German",
                    "degree": "B.A."
                },
                {
                    "name": "History",
                    "degree": "B.A."
                },
                {
                    "name": "International Relations",
                    "degree": "B.A."
                },
                {
                    "name": "Italian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Japanese",
                    "degree": "B.A."
                },
                {
                    "name": "Latin American, Latinx & Caribbean Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Linguistics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematical Economics",
                    "degree": "B.S."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.A."
                },
                {
                    "name": "Mathematics",
                    "degree": "B.S."
                },
                {
                    "name": "Music",
                    "degree": "B.A."
                },
                {
                    "name": "Music Education",
                    "degree": "B.Mus."
                },
                {
                    "name": "Neuroscience",
                    "degree": "B.S."
                },
                {
                    "name": "Philosophy",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.A."
                },
                {
                    "name": "Physics",
                    "degree": "B.S."
                },
                {
                    "name": "Political Science",
                    "degree": "B.A."
                },
                {
                    "name": "Psychology",
                    "degree": "B.A."
                },
                {
                    "name": "Religious Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Russian Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Sociology",
                    "degree": "B.A."
                },
                {
                    "name": "Spanish",
                    "degree": "B.A."
                },
                {
                    "name": "Statistics",
                    "degree": "B.S."
                },
                {
                    "name": "Theatre",
                    "degree": "B.A."
                },
                {
                    "name": "Vocal Performance",
                    "degree": "B.Mus."
                },
                {
                    "name": "Women's & Gender Studies",
                    "degree": "B.A."
                },
                {
                    "name": "Data Science",
                    "degree": "B.A.",
                    "note": "A co-major, taken together with a technical major in business analytics, computer science, statistics or mathematics."
                },
                {
                    "name": "Liberal Studies",
                    "degree": "B.A.",
                    "note": "A major you design and propose, approved by an adviser and the associate dean."
                },
                {
                    "name": "Individual Interdepartmental Major",
                    "degree": "B.A.",
                    "note": "A major you design across departments."
                }
            ]
        },
        {
            "name": "College of Engineering",
            "source": {
                "label": "Bucknell 2026-2027 Catalog, College of Engineering, Areas of Study",
                "url": "https://coursecatalog.bucknell.edu/collegeofengineeringcurricula/areasofstudy/"
            },
            "note": "Any engineering B.S. can be combined with a B.A. or with the Bachelor of Management for Engineers in a five-year program.",
            "majors": [
                {
                    "name": "Biomedical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Chemical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Civil Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Computer Science & Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Electrical Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Environmental Engineering",
                    "degree": "B.S."
                },
                {
                    "name": "Mechanical Engineering",
                    "degree": "B.S."
                }
            ]
        },
        {
            "name": "Freeman College of Management",
            "source": {
                "label": "Bucknell 2026-2027 Catalog, Freeman College of Management, Areas of Study",
                "url": "https://coursecatalog.bucknell.edu/collegeofmanagementcurricula/areasofstudy/"
            },
            "majors": [
                {
                    "name": "Accounting",
                    "degree": "BSBA"
                },
                {
                    "name": "Business Analytics",
                    "degree": "BSBA"
                },
                {
                    "name": "Finance",
                    "degree": "BSBA"
                },
                {
                    "name": "Management & Organizations",
                    "degree": "BSBA"
                },
                {
                    "name": "Markets, Innovation & Design",
                    "degree": "BSBA"
                },
                {
                    "name": "Management for Engineers",
                    "degree": "BME",
                    "note": "Only in the five-year program, together with a B.S. in an engineering discipline; your home college is the College of Engineering."
                }
            ]
        }
    ]
};

export default majors;
